import type { DripsyColor } from "@utils";
import { useDripsyColor } from "@utils";
import * as React from "react";
import Svg, { Circle, G, Path } from "react-native-svg";

function PersonsIcon({ size, color }: { size: number; color: DripsyColor }) {
  const newColor = useDripsyColor({ color });
  return (
    <Svg viewBox="0 0 512.009 512.009" height={size} width={size} fill={newColor}>
      <G>
        <G>
          <Circle cx="255.999" cy="64.005" r="64" />
        </G>
      </G>
      <G>
        <G>
          <Path d="M351.871,301.957l-14.528-113.152c-1.632-16.416-15.328-28.8-31.808-28.8h-17.536c-4.256,0-8.32,1.696-11.328,4.672    l-20.672,20.672l-20.672-20.672c-3.008-2.976-7.072-4.672-11.328-4.672h-17.504c-16.512,0-30.208,12.384-31.808,28.384    l-14.56,113.6c-0.576,4.544,0.832,9.152,3.872,12.576c3.04,3.456,7.392,5.44,12,5.44h17.28l13.376,163.2    c1.6,16.384,15.328,28.8,31.84,28.8h35.04c16.512,0,30.208-12.416,31.872-29.088l13.344-162.912h17.248    c4.608,0,8.96-1.984,12-5.44C351.071,311.141,352.479,306.533,351.871,301.957z" />
        </G>
      </G>
      <G>
        <G>
          <Circle cx="415.999" cy="64.005" r="64" />
        </G>
      </G>
      <G>
        <G>
          <Path d="M95.999,0.005c-35.296,0-64,28.704-64,64s28.704,64,64,64c35.264,0,64-28.704,64-64S131.263,0.005,95.999,0.005z" />
        </G>
      </G>
      <G>
        <G>
          <Path d="M511.871,301.957l-14.528-113.12c-1.632-16.448-15.296-28.832-31.808-28.832h-17.536c-4.256,0-8.32,1.696-11.328,4.672    l-20.672,20.672l-20.672-20.672c-3.008-2.976-7.072-4.672-11.296-4.672h-17.536c-1.984,0-3.776,0.704-5.664,1.056    c4.128,7.296,7.36,15.2,8.32,24.064l14.496,112.768c1.792,13.728-2.496,27.552-11.712,37.952    c-4.352,4.992-9.92,8.512-15.872,11.264l10.624,104.096c1.632,16.416,15.328,28.8,31.84,28.8h35.04    c16.512,0,30.208-12.416,31.872-29.088l13.312-130.912h17.248c4.608,0,8.96-1.984,12-5.44    C511.071,311.141,512.479,306.533,511.871,301.957z" />
        </G>
      </G>
      <G>
        <G>
          <Path d="M139.967,335.685c-9.088-10.272-13.312-24.064-11.584-37.728l14.56-113.632c0.832-8.512,3.968-16.192,7.968-23.296    c-1.792-0.32-3.488-1.024-5.376-1.024h-17.536c-4.256,0-8.32,1.696-11.328,4.672l-20.672,20.672l-20.672-20.672    c-3.008-2.976-7.072-4.672-11.296-4.672H46.494c-16.512,0-30.208,12.384-31.808,28.384l-14.56,113.6    c-0.576,4.544,0.832,9.152,3.872,12.576c3.04,3.456,7.424,5.44,12,5.44h17.28l13.376,131.2c1.6,16.384,15.328,28.8,31.84,28.8    h35.04c16.512,0,30.208-12.416,31.872-29.088l10.624-103.84C150.047,344.293,144.447,340.741,139.967,335.685z" />
        </G>
      </G>
    </Svg>
  );
}
export default PersonsIcon;
